import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { api } from "../../../_services/api.service";
import { userService } from "../../../_services/user.service";
import {
  Row,
  Col,
  Card,
  CardBody,
  CustomInput,
  Button,
  Table,
} from "reactstrap";
import Loader from "react-loaders";
import PageTitle from "../../../Layout/AppMain/PageTitle";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import AvField from "availity-reactstrap-validation/lib/AvField";
import GeneralGrid from "../../../Components/GeneralGrid";
import { toast } from "react-toastify";
import { formatDate } from "../../../_helpers/dateTimeHelper";
import swal from "sweetalert";

const UserSettings = (props) => {
  let userId = parseInt(props.match.params.userId);
  let partnerId = parseInt(props.match.params.partnerId);
  let [user, setUser] = useState({
    userID: -1,
    firstName: "",
    lastName: "",
    email: "",
    allTemplates: false,
    partnerID: partnerId,
    partnerRoleID: 2,
    imageUri: "",
    sendInvitation: true,
  });
  let [userScenarios, setUserScenarios] = useState([]);
  let [userPartnerScenarios, setUserPartnerScenarios] = useState([]);
  let [partnerScenarios, setPartnerScenarios] = useState([]);
  let [isLoading, setIsLoading] = useState(false);
  let [isPartnerScenariosLoading, setIsPartnerScenariosLoading] =
    useState(false);
  let [isActionSubmitting, setIsActionSubmitting] = useState(false);
  const [partner, setPartner] = useState(null);
  const [columns, setColumns] = useState([]);

  const currentUser = userService.getLoggedInUser();

  const successToastOpts = {
    autoClose: 3000,
    type: toast.TYPE.SUCCESS,
    hideProgressBar: false,
  };

  const errorToastOpts = {
    autoClose: 3000,
    type: toast.TYPE.ERROR,
    hideProgressBar: false,
  };

  useEffect(() => {
    if (userId > 0) {
      loadData(userId, partnerId);
      //loadAvatar(userId);
    }
  }, []);

  useEffect(() => {
    if (partner != undefined && partner != null) {
      setColumns([
        {
          dataField: "scenarioName",
          text: partner?.decisionName ?? "Decision",
          sort: true,
          headerStyle: () => {
            return { width: "20%" };
          },
        },
        {
          dataField: "createDT",
          text: "Date",
          sort: true,
          headerStyle: () => {
            return { width: "10%" };
          },
          formatter: (content, row) => {
            return formatDate(content, true);
          },
        },
        {
          dataField: "numObjectives",
          text: "# Criteria",
          sort: true,
          headerStyle: () => {
            return { width: "10%" };
          },
        },
        {
          dataField: "numAlternatives",
          text: "# Alternatives",
          sort: true,
          headerStyle: () => {
            return { width: "10%" };
          },
        },
        {
          dataField: "numParticipants",
          text: "# Participants",
          sort: true,
          headerStyle: () => {
            return { width: "10%" };
          },
        },
        {
          dataField: "selectedAlternativeName",
          text: "Selected Alternative",
          sort: true,
          headerStyle: () => {
            return { width: "15%" };
          },
        },
        {
          dataField: "scenarioId",
          text: "",
          sort: true,
          headerStyle: () => {
            return { width: "10%" };
          },
          formatter: (content, row) => {
            return (
              <Button
                color="primary"
                onClick={() => downloadReport(row.scenarioID)}
              >
                Download Report
              </Button>
            );
          },
        },
      ]);
    }
  }, [partner]);

  const loadData = (userId, partnerId) => {
    setIsLoading(true);
    api.getPartnerById(partnerId).then((p) => {
      setPartner(p);
    });

    api.getPartnerUserByID(userId, partnerId).then((data) => {
      if (data !== undefined && data !== null && data !== "") {
        api.getUserPhotoBase64(userId).then((uri) => {
          data.imageUri = uri;
          setUser(data);
        });
      }
      setIsLoading(false);
    });

    api.getScenariosByUserPartner(userId, partnerId).then((data) => {
      setUserScenarios(data);
    });

    setIsPartnerScenariosLoading(true);
    api.getPartnerScenariosByUserId(userId).then((ups) => {
      setUserPartnerScenarios(ups);

      api.getPartnerScenariosByPartnerId(partnerId).then((data) => {
        setIsPartnerScenariosLoading(false);
        setPartnerScenarios(
          data.map((x) => {
            if (
              ups.find((p) => p.partnerScenarioID == x.partnerScenarioID) !==
              undefined
            ) {
              x.isSelected = true;
            } else {
              x.isSelected = false;
            }
            return x;
          }),
        );
      });
    });
  };

  const handleSubmit = (e, errors, values) => {
    if (errors.length == 0) {
      if (user.userID > 0) {
        api.updatePartnerUser(currentUser.userId, user).then((data) => {
          toast("User updated successfuly", successToastOpts);
        });
      } else {
        api.createPartnerUser(currentUser.userId, user).then((id) => {
          toast("User created successfuly", successToastOpts);

          props.history.replace({
            pathname: `/usersettings/${partnerId}/${id}`,
          });
          userId = id;

          loadData(id, partnerId);
        });
      }
    }
  };

  const downloadReport = (scenarioId) => {
    if (!isActionSubmitting) {
      setIsActionSubmitting(true);
      api.getScenarioReportQueryParam(currentUser.userId).then((queryParam) => {
        setIsActionSubmitting(false);
        let url = api.getScenarioReportUrl(
          currentUser.userId,
          scenarioId,
          queryParam,
        );
        var win = window.open(url, "_blank");
        win.focus();
      });
    }
  };

  const goToDetails = (partnerScenarioID) => {
    props.history.push({
      pathname: `/decisiontemplate/${partnerId}/${partnerScenarioID}`,
    });
  };

  const changePartnerScenarioSelection = (partnerScenario) => {
    if (!isActionSubmitting) {
      isActionSubmitting = true;

      let ds = [...partnerScenarios];
      let item = ds.find(
        (d) => d.partnerScenarioID == partnerScenario.partnerScenarioID,
      );
      item.isSelected = !item.isSelected;
      let index = ds.findIndex(
        (d) => d.partnerScenarioID == partnerScenario.partnerScenarioID,
      );
      ds[index] = item;
      setPartnerScenarios(ds);

      api
        .updatePartnerScenarioUser(
          userId,
          partnerScenario.partnerScenarioID,
          item.isSelected,
        )
        .then(
          (data) => {
            setIsActionSubmitting(false);
          },
          (error) => {
            setIsActionSubmitting(false);
          },
        );
    }
  };

  const resendInvitation = () => {
    api.resendInvitation(currentUser.userId, user.userID, partnerId).then(
      (data) => {
        toast("Invitation sent successfuly", successToastOpts);
      },
      (err) => {
        toast("Could not re-send invitation", errorToastOpts);
      },
    );
  };

  const removeUser = () => {
    swal({
      text: "Are you sure you want to remove this user from your partner account?",
      icon: "warning",
      buttons: {
        ok: "Remove user",
        cancel: "Cancel",
      },
      dangerMode: true,
    }).then((val) => {
      if (val) {
        api
          .deletePartnerUser(currentUser.userId, partnerId, user.userID)
          .then((data) => {
            props.history.goBack();
          });
      }
    });
  };

  const defaultSorted = [
    {
      dataField: "ScenarioName",
      order: "asc",
    },
  ];

  const options = {
    sizePerPageList: [
      {
        text: "50",
        value: 50,
      },
    ],
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  return (
    <Fragment>
      <PageTitle icon="fas fa-user" heading={"User Settings"} />

      <Row style={{ margin: "20px" }}>
        <Col md="5">
          <div>
            {user.imageUri !== undefined && user.imageUri !== "" && (
              <img
                width={150}
                height={150}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "auto",
                }}
                className="rounded-circle"
                src={
                  user.imageUri.indexOf("base64") > -1
                    ? user.imageUri
                    : `data:image/jpeg;base64,${user.imageUri}`
                }
                alt="avatar"
              />
            )}
            {(user.imageUri == undefined || user.imageUri == "") && (
              <div
                style={{
                  width: 150,
                  height: 150,
                  margin: "auto",
                  borderRadius: 75,
                  borderWidth: 1,
                  borderColor: "white",
                  borderStyle: "solid",
                  backgroundColor: "#428AF8",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{ fontSize: 40, textAlign: "center", color: "white" }}
                >
                  {user.firstName.charAt(0) + user.lastName.charAt(0)}
                </div>
              </div>
            )}
          </div>
        </Col>

        <Col md="6">
          <Card className="main-card mb-3">
            <CardBody>
              <AvForm onSubmit={handleSubmit}>
                {user.userID == -1 && (
                  <Fragment>
                    <AvField
                      name="first"
                      label="First Name *"
                      value={user.firstName}
                      onChange={(e) =>
                        setUser({ ...user, firstName: e.target.value })
                      }
                      placeholder="Enter..."
                      required
                    />
                    <AvField
                      name="lastName"
                      label="Last Name *"
                      value={user.lastName}
                      onChange={(e) =>
                        setUser({ ...user, lastName: e.target.value })
                      }
                      placeholder="Enter..."
                      required
                    />
                    <AvField
                      name="email"
                      label="Email *"
                      value={user.email}
                      onChange={(e) =>
                        setUser({ ...user, email: e.target.value })
                      }
                      placeholder="Enter..."
                      required
                    />
                  </Fragment>
                )}
                {user.userID > 0 && (
                  <Fragment>
                    <h5>
                      {user.firstName} {user.lastName}
                    </h5>
                    <h5>{user.email}</h5>
                  </Fragment>
                )}
                <CustomInput
                  type="checkbox"
                  style={{ marginTop: "20px" }}
                  id={"pid"}
                  label={"Give Access to all Templates"}
                  checked={user.allTemplates}
                  onChange={(e) => {
                    setUser({ ...user, allTemplates: !user.allTemplates });
                  }}
                />
                <br></br>
                {user.userID == -1 && (
                  <CustomInput
                    type="checkbox"
                    style={{ marginTop: "20px" }}
                    id={"sendinv"}
                    label={"Send Invitation Email"}
                    checked={user.sendInvitation}
                    onChange={(e) => {
                      setUser({
                        ...user,
                        sendInvitation: !user.sendInvitation,
                      });
                    }}
                  />
                )}

                {user.userID > -1 && (
                  <Button
                    color="secondary"
                    style={{ margin: "5px" }}
                    onClick={() => resendInvitation()}
                  >
                    Re-send Invitation
                  </Button>
                )}
                {user.userID > -1 && (
                  <Button
                    color="danger"
                    style={{ margin: "5px" }}
                    onClick={() => removeUser()}
                  >
                    Remove User
                  </Button>
                )}

                <Button
                  color="link"
                  style={{ margin: "5px" }}
                  className="pull-right"
                  onClick={() => props.history.goBack()}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  style={{ margin: "5px" }}
                  type="submit"
                  className="pull-right"
                >
                  Save
                </Button>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {user !== null && user.userID > 0 && (
        <Fragment>
          <Row style={{ marginTop: "30px" }}>
            <Col md="11">
              <Card className="main-card mb-3">
                <CardBody>
                  <Row>
                    <Col md="6">
                      <div className="card-title">Templates</div>
                    </Col>
                  </Row>

                  {isPartnerScenariosLoading && (
                    <Loader style={{}} type="ball-pulse" active />
                  )}
                  {!isPartnerScenariosLoading && (
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th width="15%">Selected</th>
                          <th>Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {partnerScenarios.map((x) => {
                          return (
                            <tr key={x.partnerScenarioID}>
                              <td>
                                <CustomInput
                                  type="checkbox"
                                  id={`vv-${x.partnerScenarioID}`}
                                  checked={x.isSelected}
                                  onChange={(e) => {
                                    changePartnerScenarioSelection(x);
                                  }}
                                />
                              </td>
                              <td>{x.partnerScenarioName}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row style={{ marginTop: "30px" }}>
            <Col md="11">
              <Card className="main-card mb-3">
                <CardBody>
                  {isLoading && <Loader style={{}} type="ball-pulse" active />}
                  {!isLoading && columns.length > 0 && (
                    <Row>
                      <GeneralGrid
                        title={`User ${partner?.decisionName ?? "Decision"}s`}
                        keyField="ScenarioID"
                        defaultSortedColumn="ScenarioName"
                        dataSource={userScenarios}
                        filterColumns={["ScenarioName"]}
                        columns={columns}
                        showAddButton={true}
                        defaultSorted={defaultSorted}
                        options={options}
                        onAdd={() => goToDetails(-1)}
                      />
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Fragment>
      )}
    </Fragment>
  );
};

export default UserSettings;
